import { render, staticRenderFns } from "./BuildNotice.vue?vue&type=template&id=5976eb26&scoped=true"
import script from "./BuildNotice.vue?vue&type=script&lang=js"
export * from "./BuildNotice.vue?vue&type=script&lang=js"
import style0 from "./BuildNotice.vue?vue&type=style&index=0&id=5976eb26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5976eb26",
  null
  
)

export default component.exports